import React, { Component } from 'react'
import Highcharts, { Chart } from 'highcharts';

interface DataPoint
{
	label: string
	value: number
}
export interface SparklineProps
{
	chartData: DataPoint[]
	tooltipHeader: string
}
export default class SparkLine extends Component<SparklineProps>
{
	protected container: HTMLSpanElement;
	protected chart: Chart;
	/**
	 * (for full list of available options visit: https://api.highcharts.com/highcharts/)
	 */
	protected defaultOptions: any = {
		chart: {
			backgroundColor: null,
			borderWidth: 0,
			type: 'area',
			margin: [2, 0, 2, 0],
			width: 120,
			height: 20,
			style: {
				overflow: 'visible'
			},
			// small optimalization, saves 1-2 ms each Sparkline
			skipClone: true
		},
		title: {
			text: ''
		},
		credits: {
			enabled: false
		},
		xAxis: {
			labels: {
				enabled: false
			},
			title: {
				text: null
			},
			startOnTick: false,
			endOnTick: false,
			tickPositions: []
		},
		yAxis: {
			endOnTick: false,
			startOnTick: false,
			labels: {
				enabled: false
			},
			title: {
				text: null
			},
			tickPositions: [0]
		},
		legend: {
			enabled: false
		},
		tooltip: {
			backgroundColor: 'white',
			borderWidth: 1,
			hideDelay: 0,
			shared: true,
			padding: 8,
			borderColor: 'silver',
			borderRadius: 3,
			positioner: function (w: number, h: number, point: any) {
				return {
					x: point.plotX - w / 2, 
					y: point.plotY - h - 6
				};
			}
		},
		plotOptions: {
			series: {
				color: "#1D428A",
				animation: false,
				lineWidth: 2,
				shadow: false,
				states: {
					hover: {
						lineWidth: 1
					}
				},
				marker: {
					radius: 1,
					states: {
						hover: {
							radius: 2
						}
					}
				},
				fillOpacity: 0.25
			},
			column: {
				negativeColor: '#910000',
				borderColor: 'silver'
			}
		},
		exporting: {
			enabled: false
		}
	};

	componentDidMount()
	{
		// extract data point values
		const data = this.props.chartData.map(dp => {
			return dp.value;
		});
		// define the formatting function pass in chart data and header
		const formatter = (chartData: DataPoint[], header: string) => {
			return function() {
				const dataPoint: DataPoint = chartData[this.x -1];
				return `<b>${header}, ${dataPoint.label}</b><br/>${dataPoint.value}`;
			};
		}
		// build chart specific options
		const options: any = {
			series: [{
				data,
				pointStart: 1
			}],
			tooltip: {
				formatter: formatter(this.props.chartData, this.props.tooltipHeader)
			}
		};
		// merge with default options to create overall chartOptions
		const chartOptions = Highcharts.merge(this.defaultOptions, options);
		// initialise the chart
		this.chart = Highcharts.chart(this.container, chartOptions);
	};

	componentDidUpdate()
	{
		if ( this.chart ) {
			this.chart.reflow();
		}
	};

	componentWillUnmount()
	{
		if ( this.chart ) {
			this.chart.destroy();
		}
	};

	render()
	{
		return (
			<span ref={(container: HTMLSpanElement | null) => {this.container = container}} className="ajb-sparkline-chart"></span>
		);
	};
}